/**
 * Simple logger utility for development and debugging
 */

interface Logger {
  log: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  error: (...args: any[]) => void;
  info: (...args: any[]) => void;
  debug: (...args: any[]) => void;
}

const logger: Logger = {
  log: (...args) => {
    void args;
  },
  
  warn: (...args) => {
    void args;
  },
  
  error: (...args) => {
    void args;
  },
  
  info: (...args) => {
    void args;
  },
  
  debug: (...args) => {
    void args;
  }
};

export default logger;